import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import {environment} from '../../environments/environment';
import { Module } from 'app/models/module.model';

@Injectable({
    providedIn: 'root'
})
export class ModuleService {

    private API_URL= environment.API_URL;
    private MODEL_URL = 'modules';

    constructor(private http: HttpClient) { }

    getModules(): Observable<Module[]> {
        return this.http.get<Module[]>(this.API_URL + this.MODEL_URL);
    }

    getModulesForUser(user_id: string): Observable<Module[]> {
        return this.http.get<Module[]>(this.API_URL + this.MODEL_URL + '/' + user_id);
    }
}
